class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    const warmStyles = () => document.querySelectorAll('link[data-rd-style-href]').forEach(link => {
      if (!link.href) link.href = link.dataset.rdStyleHref;
    });
    ['pointerenter', 'focus', 'touchstart'].forEach(event => cartLink.addEventListener(event, warmStyles, { passive: true }));
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  async open(triggeredBy) {
    const opening = (this.opening || 0) + 1;
    this.opening = opening;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const stylesReady = await Promise.all([...document.querySelectorAll('link[data-rd-cart-style]')].map(link => {
      if (link.dataset.rdStyleFailed === 'true') return false;
      if (link.sheet || link.dataset.rdStyleReady === 'true') {
        link.media = 'all';
        return true;
      }
      return new Promise(resolve => {
        const finish = success => {
          clearTimeout(timeout);
          link.removeEventListener('load', loaded);
          link.removeEventListener('error', failed);
          if (success) { link.media = 'all'; link.dataset.rdStyleReady = 'true'; }
          else link.dataset.rdStyleFailed = 'true';
          resolve(success);
        };
        const loaded = () => finish(true);
        const failed = () => finish(false);
        const timeout = setTimeout(failed, 8000);
        link.addEventListener('load', loaded, { once: true });
        link.addEventListener('error', failed, { once: true });
        if (link.dataset.rdStyleHref && !link.href) link.href = link.dataset.rdStyleHref;
      });
    }));
    if (this.opening !== opening) return;
    if (stylesReady.some(ready => !ready)) {
      window.location.assign(window.routes?.cart_url || '/cart');
      return;
    }
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      if (this.opening !== opening) return;
      this.classList.add('animate', 'active');
      window.RDCartUpsell?.revealImages(this);
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('.drawer__inner');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.opening = (this.opening || 0) + 1;
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* Info pop-ups (delivery times in the shipping bar). Hover on desktop is CSS; this handles tap,
   outside tap and Escape. Markup: [data-rd-info] > .rd-info__btn + .rd-info__pop. */
(function () {
  if (window.rdInfoPopupsBound) return;
  window.rdInfoPopupsBound = true;
  var swallowKeyup = false;

  function closeAll(except) {
    document.querySelectorAll('[data-rd-info].is-open').forEach(function (el) {
      if (el === except) return;
      el.classList.remove('is-open');
      var b = el.querySelector('.rd-info__btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.rd-info__btn');
    if (btn) {
      var wrap = btn.closest('[data-rd-info]');
      var open = !wrap.classList.contains('is-open');
      closeAll(wrap);
      wrap.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!event.target.closest('.rd-info__pop')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (document.querySelector('[data-rd-info].is-open')) {
      closeAll();
      swallowKeyup = true; /* the drawer closes on Escape keyup: let this Escape only close the pop-up */
    }
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape' && swallowKeyup) {
      swallowKeyup = false;
      event.stopPropagation();
    }
  }, true);
})();
